import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeStatusIcon } from "../Icons/IssueTypeStatusIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface IssueTypeStatusMultiSelectGroupProps extends MenuMultiSelectGroupProps<Stored<IssueTypeStatus>> {
	issueTypeStatuses: Stored<IssueTypeStatus>[]
}

export const IssueTypeStatusMultiSelectGroup = memo<IssueTypeStatusMultiSelectGroupProps>((props) => {
	const { ref, issueTypeStatuses, ...rest } = props

	return (
		<Menu.MultiSelectGroup<Stored<IssueTypeStatus>> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{issueTypeStatuses.map((issueTypeStatus) => (
				<MultiSelectItemTemplate<Stored<IssueTypeStatus>> key={issueTypeStatus.uuid} value={issueTypeStatus}>
					<IssueTypeStatusIcon issueTypeStatusId={issueTypeStatus.uuid} />
					<Text className="truncate">{issueTypeStatus.name}</Text>
				</MultiSelectItemTemplate>
			))}
		</Menu.MultiSelectGroup>
	)
})
IssueTypeStatusMultiSelectGroup.displayName = "IssueTypeStatusMultiSelectGroup"
